import type { RouteObject } from 'react-router';

import * as compensationSurveyHorizonRouteExports from '#/modules/salaries/pages/CompensationSurvey/CompensationSurvey.horizon-route';
import * as salaryReportHorizonRouteExports from '#/modules/salaries/pages/SalaryReport/SalaryReport.horizon-route';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

import { salariesExploreRoute, salariesSurveyRoute } from './salaries.routes';

export const salariesRouteObjects = [
  {
    path: salariesExploreRoute.fullPath,
    ...horizonRouteToObject(salaryReportHorizonRouteExports),
  },
  {
    path: salariesSurveyRoute.fullPath,
    ...horizonRouteToObject(compensationSurveyHorizonRouteExports),
  },
] satisfies RouteObject[];
